export const usersPath = () => "/users";
